export const HoverMixin = {
  onMouseEnter: function onMouseEnter() {
    this.setState({hovered: true});
  },
  onMouseLeave: function onMouseLeave() {
    this.setState({hovered: false});
  }
};
